import { ScheduleConfig } from 'src/app/modules/campaign-management/campaigns/models/wizard.model';

export function generateScheduleDTO(schedules: ScheduleConfig[], timezone: string): any[] {
  const dayOfWeekMap: { [key: string]: string } = {
    Sunday: '0',
    Monday: '1',
    Tuesday: '2',
    Wednesday: '3',
    Thursday: '4',
    Friday: '5',
    Saturday: '6',
  };

  const monthMap: { [key: string]: string } = {
    January: '1',
    February: '2',
    March: '3',
    April: '4',
    May: '5',
    June: '6',
    July: '7',
    August: '8',
    September: '9',
    October: '10',
    November: '11',
    December: '12',
  };

  return schedules.map((sched) => {
    const cron: any = {
      minute: parseInt(sched.minute, 10).toString(),
      hour: '*',
      dayOfMonth: '*',
      month: '*',
      dayOfWeek: '*',
      second: '*',
      year: '*',
      timezone: timezone,
    };

    switch (sched.frequency) {
      case 'Hour':
        break;
      case 'Day':
        cron.hour = parseInt(sched.hour, 10).toString();
        break;

      case 'Week':
        cron.hour = parseInt(sched.hour, 10).toString();
        cron.dayOfWeek = dayOfWeekMap[sched.dayOfWeek];
        break;

      case 'Month':
        cron.hour = parseInt(sched.hour, 10).toString();
        cron.dayOfMonth = parseInt(sched.dayOfMonth, 10).toString();
        break;

      case 'Year':
        cron.hour = parseInt(sched.hour, 10).toString();
        cron.dayOfMonth = parseInt(sched.dayOfMonth, 10).toString();
        cron.month = monthMap[sched.month];
        break;
    }

    return cron;
  });
}
